import BasicLink from "app/components/basic/Link";

export const GuidesEmail = (email: string): JSX.Element => {
	return <BasicLink id={`guides-email__${email}`} name={email} href={`mailto:${email}`} disablePrefetch={true} />;
};
